module.exports = __webpack_public_path__ + "static/52095305086_4ca0a76a3c_o-800x500-2d2d1582d85ff8abe31b4680f26cbfc7.jpg";